/* eslint-disable max-len */
/* eslint-disable react/jsx-closing-bracket-location */
import Grid from '@material-ui/core/Grid';
import React, { Component } from 'react';

import Button from '@material-ui/core/Button';
import { withTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { amountFormate } from '../../AppUtil/AppUtil';
import Loader from '../Common/Loader';
import BaseGrid from './UpdateLoanGrids/BaseGrid';
import HeaderGrid from './UpdateLoanGrids/GridForHeader';

const APP_IMAGES = window.AppConfig.APP_IMAGES;

class Forgive extends Component {
	genrateButton = (name, action) => {
		return (
			<Grid className="no-shadow" container id="reduce-width" justify="center" spacing={2}>
				<Grid id="shadow-round" item sm={8} spacing={2} xs={12}>
					<Button
						aria-label="add"
						className="back-btn-large-review btn-green"
						fullWidth
						onClick={action}
						// style={{ backgroundColor: 'red', color: 'white' }}
						type="submit"
						variant="extended">
						{this.props.t(name)}
					</Button>
				</Grid>
			</Grid>
		);
	};

	toastWhenForgive = () => {
		const loanObject = this.props.loanObject;
		let forgiveBalance = 0;
		for (var object in loanObject.installments) {
			if (loanObject.installments[object].state === 'DUE') {
				forgiveBalance += parseFloat(loanObject.installments[object].emi_amount);
			}
		}
		const amountWithSeparator = amountFormate(parseFloat(forgiveBalance).toFixed(2));

		Swal.fire({
			title: this.props.t('sweetalert_title.are_you_sure_forgive_loan', { amount: amountWithSeparator }),
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#3085d6',
			cancelButtonColor: '#d33',
			confirmButtonText: this.props.t('buttons.yes'),
			customClass: 'otp_message_success'
		}).then(result => {
			if (result.value) {
				this.props.paymentAction('FORGIVE_LOAN', this.forgiveLoan, this.toastSomethingWentWrong);
			}
		});
	};

	forgiveLoan = () => {
		Swal.fire({
			animation: false,
			title: this.props.t('label.success'),
			text: this.props.t('app_message.you_have_successfully_forgiven_the_loan'),
			icon: 'success',
			customClass: 'otp_message_success'
		});
	};

	toastSomethingWentWrong = () => {
		Swal.fire({
			title: this.props.t('sweetalert_title.error'),
			text: this.props.t('error_message.something_went_wrong'),
			imageUrl: 'https://cdn-icons-png.flaticon.com/512/5219/5219070.png',
			imageAlt: 'Custom Image',
			// icon: 'error',
			confirmButtonText: this.props.t('buttons.try_again'),
			customClass: 'otp_message_success'
		});
	};

	genrateForgivePaymentButTxt = () => {
		const loanObject = this.props.loanObject;
		let forgiveBalance = 0;
		for (var object in loanObject.installments) {
			if (loanObject.installments[object].state === 'DUE') {
				forgiveBalance += parseFloat(loanObject.installments[object].emi_amount);
			}
		}
		const amountWithSeparator = amountFormate(parseFloat(forgiveBalance).toFixed(2));
		// return this.props.t('error_message.you_are_forgiving_the_loan_balance', { amount: amountWithSeparator });

		return (
			<>
				You are forgiving the Loan Balance of{' '}
				<span
					className="bold-important"
					style={{
						whiteSpace: 'nowrap'
					}}>
					₱ {amountWithSeparator}
				</span>
			</>
		);
	};

	render() {
		const { t } = this.props;
		return (
			<section>
				<BaseGrid>
					<HeaderGrid>
						<img
							alt="Invite"
							className="img-reponsive"
							src={APP_IMAGES.FORGIVE}
							style={{ maxWidth: '100%', maxHeight: 'initial' }}
						/>
						<h4 className="text-center">{t('label.forgive_balance_of_loan')}</h4>
					</HeaderGrid>
					<Grid className="no-shadow" container id="reduce-width" justify="center" spacing={2}>
						<Grid id="shadow-round" item spacing={2} xs={12}>
							<p className="text-center">{this.genrateForgivePaymentButTxt()}</p>
						</Grid>
					</Grid>
					{this.genrateButton('buttons.confirm', this.toastWhenForgive)}
					{this.genrateButton('buttons.cancel', this.props.onBack)}
				</BaseGrid>
				{this.props.isLoading ? <Loader /> : ''}
			</section>
		);
	}
}

export default withTranslation()(Forgive);
